import React, { useState, useEffect } from "react";
import { getLotteryList } from "../../../api/lottery/lotteryApi";
import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../lib/BackBtn";

interface LotteryResult {
  men: Array<{
    firstName: string;
    lastName: string;
    nationalCode: string;
    mobile: string;
  }>;
  women: Array<{
    firstName: string;
    lastName: string;
    nationalCode: string;
    mobile: string;
  }>;
}

function LotteryDetails() {
  const location = useLocation();
  const matchId = location.state;
  const navigate = useNavigate();

  const [wonData, setWonData] = useState<LotteryResult | null>(null);
  const [reservedData, setReservedData] = useState<LotteryResult | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [matchInfo, setMatchInfo] = useState<string>("");

  useEffect(() => {
    fetchLotteryData();
  }, [matchId]);

  const fetchLotteryData = async () => {
    try {
      setLoading(true);

      const params: any = {
        page: 1,
        numberInPage: 100,
      };

      if (matchId) {
        params.match = matchId;
      }

      const lotteryResponse = await getLotteryList(params);

      const reservedItems = lotteryResponse.data?.filter(
        (item: any) => item.type === "reserved"
      );
      const wonItems = lotteryResponse.data?.filter(
        (item: any) => item.type === "won"
      );
      if (lotteryResponse.data.length > 0 && lotteryResponse.data[0].match) {
        const match = lotteryResponse.data[0].match;
        setMatchInfo(
          `${match.homeTeam?.nameFA || "تیم میزبان"} - ${
            match.awayTeam?.nameFA || "تیم مهمان"
          }`
        );
      }

      const transformedWonData: LotteryResult = {
        men: wonItems
          .filter((item: any) => item.male)
          .map((item: any) => ({
            firstName: item.ticket?.attendee?.name?.split(' ')[0] || "",
            lastName: item.ticket?.attendee?.name?.split(' ').slice(1).join(' ') || "",
            nationalCode: item.nationalCode || item.ticket?.attendee?.national_code || "",
            mobile: item.phone || item.ticket?.attendee?.mobile || "",
          })),
        women: wonItems
          .filter((item: any) => !item.male)
          .map((item: any) => ({
            firstName: item.ticket?.attendee?.name?.split(' ')[0] || "",
            lastName: item.ticket?.attendee?.name?.split(' ').slice(1).join(' ') || "",
            nationalCode: item.nationalCode || item.ticket?.attendee?.national_code || "",
            mobile: item.phone || item.ticket?.attendee?.mobile || "",
          })),
      };

      const transformedReservedData: LotteryResult = {
        men: reservedItems
          .filter((item: any) => item.male)
          .map((item: any) => ({
            firstName: item.ticket?.attendee?.name?.split(' ')[0] || "",
            lastName: item.ticket?.attendee?.name?.split(' ').slice(1).join(' ') || "",
            nationalCode: item.nationalCode || item.ticket?.attendee?.national_code || "",
            mobile: item.phone || item.ticket?.attendee?.mobile || "",
          })),
        women: reservedItems
          .filter((item: any) => !item.male)
          .map((item: any) => ({
            firstName: item.ticket?.attendee?.name?.split(' ')[0] || "",
            lastName: item.ticket?.attendee?.name?.split(' ').slice(1).join(' ') || "",
            nationalCode: item.nationalCode || item.ticket?.attendee?.national_code || "",
            mobile: item.phone || item.ticket?.attendee?.mobile || "",
          })),
      };

      setWonData(transformedWonData);
      setReservedData(transformedReservedData);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const goBack = () => navigate(-1);

  return (
    <>
      {loading ? (
        <div className="card">
          <div
            className="card-body d-flex justify-content-center align-items-center"
            style={{ minHeight: "200px" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">در حال بارگذاری...</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          {matchInfo && (
            <div className="card mb-5">
              <div className="card-body">
                <h4 className="text-center">قرعه کشی بازی: {matchInfo}</h4>
              </div>
            </div>
          )}

          {wonData && (wonData.men.length > 0 || wonData.women.length > 0) && (
            <div className="card mb-5">
              <div
                className={
                  "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
                }
              >
                <h2> لیست برنده‌ها</h2>
                <BackBtn onClick={goBack} />
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-6">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">آقایان</h3>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                              <tr className="fw-bold text-muted">
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>شماره موبایل</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wonData.men.length > 0 ? (
                                wonData.men.map((person, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{person.firstName}</td>
                                    <td>{person.lastName}</td>
                                    <td>{person.nationalCode}</td>
                                    <td>{person.mobile}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    اطلاعاتی یافت نشد
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">خانم‌ها</h3>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                              <tr className="fw-bold text-muted">
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>شماره موبایل</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wonData.women.length > 0 ? (
                                wonData.women.map((person, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{person.firstName}</td>
                                    <td>{person.lastName}</td>
                                    <td>{person.nationalCode}</td>
                                    <td>{person.mobile}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    اطلاعاتی یافت نشد
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {reservedData &&
            (reservedData.men.length > 0 || reservedData.women.length > 0) && (
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">لیست رزروها</h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">آقایان</h3>
                        </div>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                              <thead>
                                <tr className="fw-bold text-muted">
                                  <th>ردیف</th>
                                  <th>نام</th>
                                  <th>نام خانوادگی</th>
                                  <th>کد ملی</th>
                                  <th>شماره موبایل</th>
                                </tr>
                              </thead>
                              <tbody>
                                {reservedData.men.length > 0 ? (
                                  reservedData.men.map((person, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{person.firstName}</td>
                                      <td>{person.lastName}</td>
                                      <td>{person.nationalCode}</td>
                                      <td>{person.mobile}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      اطلاعاتی یافت نشد
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">بانوان</h3>
                        </div>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                              <thead>
                                <tr className="fw-bold text-muted">
                                  <th>ردیف</th>
                                  <th>نام</th>
                                  <th>نام خانوادگی</th>
                                  <th>کد ملی</th>
                                  <th>شماره موبایل</th>
                                </tr>
                              </thead>
                              <tbody>
                                {reservedData.women.length > 0 ? (
                                  reservedData.women.map((person, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{person.firstName}</td>
                                      <td>{person.lastName}</td>
                                      <td>{person.nationalCode}</td>
                                      <td>{person.mobile}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      اطلاعاتی یافت نشد
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {(!wonData ||
            (wonData.men.length === 0 && wonData.women.length === 0)) &&
            (!reservedData ||
              (reservedData.men.length === 0 &&
                reservedData.women.length === 0)) && (
              <div className="card">
                <div className="card-body text-center p-10">
                  <h3>هیچ اطلاعاتی برای نمایش وجود ندارد</h3>
                  {matchId ? (
                    <p>هنوز هیچ قرعه‌کشی برای این بازی انجام نشده است</p>
                  ) : (
                    <p>هنوز هیچ قرعه‌کشی انجام نشده است</p>
                  )}
                </div>
                <BackBtn onClick={goBack} />
              </div>
            )}
        </>
      )}
    </>
  );
}

export default LotteryDetails;
